var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.visible
    ? _c("div", { ref: "root", staticClass: "wkb-explanation-bubble-root" }, [
        _vm.pickerOpen
          ? _c(
              "div",
              {
                staticClass: "wkb-explanation-bubble-picker",
                attrs: {
                  role: "listbox",
                  "aria-label": "Choose an explanation",
                },
              },
              _vm._l(_vm.numberedEntries, function (item) {
                return _c(
                  "button",
                  {
                    key: item.id,
                    staticClass: "wkb-explanation-bubble-picker-item",
                    attrs: { type: "button", role: "option" },
                    on: {
                      click: function ($event) {
                        return _vm.onPick(item.id)
                      },
                    },
                  },
                  [
                    _c(
                      "span",
                      { staticClass: "wkb-explanation-bubble-picker-title" },
                      [_vm._v(" Explanation " + _vm._s(item.number) + " ")]
                    ),
                    _c(
                      "span",
                      { staticClass: "wkb-explanation-bubble-picker-meta" },
                      [
                        _vm._v(" " + _vm._s(item.scopeLabel)),
                        item.timestampLabel
                          ? [_vm._v(" · " + _vm._s(item.timestampLabel))]
                          : _vm._e(),
                      ],
                      2
                    ),
                  ]
                )
              }),
              0
            )
          : _vm._e(),
        _c(
          "button",
          {
            staticClass: "wkb-explanation-bubble-btn",
            attrs: { type: "button", "aria-expanded": _vm.pickerOpen },
            on: { click: _vm.onBubbleClick },
          },
          [_vm._v(" Explanation " + _vm._s(_vm.explanationCount) + " ")]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }